import React, { Component } from "react";
import styled from "styled-components";

const images = ["coffee01", "coffee02", "coffee03"];

class IntroSection extends Component {
  render() {
    return (
      <Wrapper>
        <div className="container">
          <div className="title">
            <span>關於我們</span>
            {images.map((d, i) => (
              <img key={i} src={`/images/pages/about/icon-${d}.png`} />
            ))}
          </div>
          <div className="text">
            咖啡不只是用來提神的飲品，而是個人品味的延伸。好咖嚴選的每一間店家都有著對咖啡的堅持與熱情，請讓我們陪伴您一起發現咖啡之美，使享受美好成為您生活隨手可得的習慣。
          </div>
        </div>

        <div className="container">
          <div className="title">
            <span>好咖使命</span>
          </div>
          <div className="text">
            台灣有許多獨具特色的精品咖啡店，他們隱身在巷弄中，等待與您來一場偶然的不期而遇。店裡的職人們各個身懷絕藝，傾全力將熱情及專業灌注在每一杯上桌的咖啡中。我們希望藉由這個好咖嚴選平台，讓更多人認識精品咖啡與品牌店家的理念，讓更多人喜愛並找到自己咖啡品味。
          </div>
        </div>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  border-bottom: 0.5px dashed #bd9f84;
  padding: 70px 10px;
  width: 100%;

  & > .container {
    margin-bottom: 70px;
    & > .title {
      display: flex;
      align-items: center;
      margin-bottom: 42px;

      & > span {
        margin-right: 7px;
        letter-spacing: 3.9px;
        font-weight: 500;
        font-size: 26px;
      }

      & > img {
        width: 50px;
        height: 50px;
      }
    }

    & > .text {
      line-height: 40px;
      font-size: 14px;
      color: #353535;
    }

    :last-child {
      margin-bottom: 0px;
    }
  }
`;

export default IntroSection;
